import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {User} from '../models/user.model';
import {UserService} from '../services/user.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ReportDatepickerComponent} from '../modals/report-datepicker.component';
import {ReportType} from '../models/report-type.model';
import {SidebarService} from '../services/side-bar.service';
import {AuthService} from '../services/auth.service';
import {Router} from '@angular/router';
import {NotificationsService} from '../services/notifications.service';
import {OperatingStandardService} from '../services/operating-standard.service';
import {StepsControllerService} from '../services/steps-controller.service';
import {SuggestionListsService} from '../content-page/common/suggestion-lists/services/suggestion-lists.service';
import {ApiConnectService} from '../services/api-connect.service';
import {TreeGroupPosService} from '../content-page/admin/create-operating-standard/tree-group-pos-service/tree-group-pos.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  private user: User;
  isAdmin = false;
  isHead = false;
  isUser = false;
  specialRole = false;
  id;

  constructor(private userService: UserService,
              private authService: AuthService,
              public sidebarService: SidebarService,
              private modalService: NgbModal,
              private router: Router,
              public apiConnectService: ApiConnectService,
              private treeGroupPosService: TreeGroupPosService,
              public stepsControllerService: StepsControllerService,
              public operatingStandardService: OperatingStandardService,
              private suggestionListsService: SuggestionListsService) {
              this.id = this.userService.getLocal().id;
  }

  @Output() featureSelected = new EventEmitter<string>();

  ngOnInit() {
    this.user = this.userService.getLocal();
    if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
      this.isHead = true;
    } else {
      this.isHead = false;
    }
    if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }
    if (this.user.roles.indexOf('ROLE_USER') !== -1) {
      this.isUser = true;
    } else {
      this.isUser = false;
    }
    if (this.user.roles.indexOf('ROLE_ADMIN_SPECIALIZATION') !== -1) {
      this.specialRole = true;
    } else {
      this.specialRole = false;
    }
  }

  goToCreateSt() {
    this.stepsControllerService.leaveComponent();
    this.treeGroupPosService.clearPositionsForServerLists();
    this.router.navigate(['/dashboard/create-operating-standard']);
  }

  openReportDatepicker() {
    const modalRef = this.modalService.open(ReportDatepickerComponent);
    modalRef.componentInstance.reportType = ReportType.BY_USER;
    modalRef.componentInstance.userId = this.userService.getLocal().id;
  }

  goToNewSL() {
    this.suggestionListsService.setListType('free');
    this.suggestionListsService.clearSLData();
    this.router.navigate(['/dashboard/create-suggestion-list']);
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/navbar/navbar.component.ts